import {
  gql,
  MutationHookOptions,
  OperationVariables,
  useMutation,
} from '@apollo/client';

import { UserSuccessOutput } from './types';

export interface IConfigureIdentityProvider {
  configureIdentityProvider: UserSuccessOutput;
}

export const CONFIGURE_IDENTITY_PROVIDER = gql`
  mutation configureIdentityProvider(
    $attribute_mapping: String!
    $idp_identifiers: [String]
    $provider_details: String!
    $provider_type: String!
    $idp_user_role_mapping: String
  ) {
    configureIdentityProvider(
      attribute_mapping: $attribute_mapping
      idp_identifiers: $idp_identifiers
      provider_details: $provider_details
      provider_type: $provider_type
      idp_user_role_mapping: $idp_user_role_mapping
    ) {
      status_code
      body {
        data
        message
        success
      }
    }
  }
`;

export const useConfigureIdentityProvider = (
  options: MutationHookOptions<IConfigureIdentityProvider, OperationVariables>,
) => {
  return useMutation<IConfigureIdentityProvider, OperationVariables>(
    CONFIGURE_IDENTITY_PROVIDER,
    options,
  );
};
